// Ready Function Start
$(document).ready(function () {
  var PageURL = window.location.href;
  var HomePage = {
    collapableContent() {
      $(document).on("click", ".collapse_head", function () {
        $(this).parent(".collapsableParent").find(".collapableTab").toggle();
        $(this).toggleClass("active");
      });
    },
  };
  if (PageURL.indexOf("collection") > -1 || PageURL.indexOf("/") > -1) {
    HomePage.collapableContent();
  }
});
// Ready Function End
